/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Charge/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Charge({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Charge",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#8951E3"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Charge.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-ZMLOen': alignSelf,'--mt-2-ZMLOen': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZMLOen': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZMLOen': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZMLOen': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZMLOen': opacity,'--w-10-ZMLOen': typeof width === 'number' ? `${width}px` : width,'--h-11-ZMLOen': typeof height === 'number' ? `${height}px` : height,'--f-12-ZMLOen': fill,'--a-7-ZMLOen': isAnimated ? animation : "none",'--sd-8-ZMLOen': isAnimated ? strokeDashoffset : 0,'--sd-9-ZMLOen': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Charge.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.548 3.29A2.003 2.003 0 018.419 2h2.856a2.003 2.003 0 011.862 1.265 3.895 3.895 0 012.762 3.327l.186 1.694a1.73 1.73 0 011.573 1.936l-.797 6.007-.008.065c-.017.15-.046.4-.14.626a1.773 1.773 0 01-1.132 1.012c-.24.07-.484.068-.633.066H4.78c-.163.003-.435.008-.69-.066a1.773 1.773 0 01-1.132-1.012c-.107-.26-.14-.568-.158-.754a3.823 3.823 0 00-.012-.1l-.76-5.729a2.075 2.075 0 01-.015-.554 1.739 1.739 0 011.596-1.498l.186-1.696v-.001A3.895 3.895 0 016.549 3.29zm.175 1.777A2.168 2.168 0 005.51 6.78l-.166 1.503h9.004l-.166-1.504v-.005a2.168 2.168 0 00-1.202-1.722 2.005 2.005 0 01-1.706.955H8.419a2.003 2.003 0 01-1.696-.939zm5.544 9.508a.719.719 0 10-1.22-.764c-.002.005-.023.032-.068.072-.05.045-.122.1-.217.15-.188.103-.47.198-.861.198-.794 0-1.229-.394-1.291-.475a.72.72 0 00-1.142.874c.324.423 1.175 1.04 2.433 1.04 1.263 0 2.07-.625 2.366-1.095zm-3.653-2.783a.863.863 0 11-1.726 0 .863.863 0 011.726 0zm3.331.863a.863.863 0 100-1.726.863.863 0 000 1.726z"
 style={{'--f-12-ZMLOen': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}